import { GUID, Param } from "app/brightserve/brightserve.module";

export class IncidentFinding {
    Id: GUID;
    Author: string;
    Created: Date;
    Text: string;
    Status: Param;

    constructor(init?: Partial<IncidentFinding>) {
        Object.assign(this, init);

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };
    }

    static BlankIncidentFinding(init?: any) {
        var incidentDetail = new IncidentFinding(init);
        incidentDetail.Id = GUID.newGuid();
        incidentDetail.Status = new Param();
        return incidentDetail;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/incident-finding.ts